"use strict";

var _regeneratorRuntime = require("/codebuild/output/src400645628/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactRouterDom = require("react-router-dom");

var _uiKit = require("@devsta/ui-kit");

var _whyShootsta = _interopRequireDefault(require("../../../../../common/constants/whyShootsta.vtt"));

var _FormHeader = _interopRequireDefault(require("../../../../../common/components/FormHeader"));

require("../styles/_organisation-invite.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var OrganisationWelcomeContent = /*#__PURE__*/function (_Component) {
  _inherits(OrganisationWelcomeContent, _Component);

  function OrganisationWelcomeContent(props) {
    var _this;

    _classCallCheck(this, OrganisationWelcomeContent);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(OrganisationWelcomeContent).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "areCaptionsVisible", function () {
      var video = _this.state.video;
      return Boolean(video && video.textTracks[0].mode === 'showing');
    });

    _defineProperty(_assertThisInitialized(_this), "setCaptionsVisible", function () {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref$visible = _ref.visible,
          visible = _ref$visible === void 0 ? true : _ref$visible;

      var video = _this.state.video;

      if (!video) {
        return;
      } // This is the only way of updating DOM elements directly
      // eslint-disable-next-line no-param-reassign


      video.textTracks[0].mode = visible ? 'showing' : 'hidden';
    });

    _defineProperty(_assertThisInitialized(_this), "fetchVideo", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var getWelcomeVideoUrl, _ref3, data, error;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              getWelcomeVideoUrl = _this.props.getWelcomeVideoUrl;

              _this.setState({
                saving: true
              });

              _context.next = 4;
              return getWelcomeVideoUrl();

            case 4:
              _ref3 = _context.sent;
              data = _ref3.data;
              error = _ref3.error;

              if (!(error || !data)) {
                _context.next = 9;
                break;
              }

              return _context.abrupt("return", void _this.setState({
                error: error,
                saving: false
              }));

            case 9:
              _this.setState({
                videoUrl: data.getS3SignedUrl,
                saving: false
              });

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));

    _defineProperty(_assertThisInitialized(_this), "getVideo", function (el) {
      var video = _this.state.video;

      if (video || !el) {
        return;
      }

      el.addEventListener('pause', _this.handleStop);

      _this.setState({
        video: el
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handlePlay", function () {
      var _this$state = _this.state,
          video = _this$state.video,
          captionsVisible = _this$state.captionsVisible;

      if (!video) {
        return;
      }

      video.play();

      if (captionsVisible && !_this.areCaptionsVisible()) {
        _this.setCaptionsVisible();
      }

      _this.setState({
        playing: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleStop", function () {
      _this.setState({
        playing: false,
        captionsVisible: _this.areCaptionsVisible()
      }, function () {
        _this.setCaptionsVisible({
          visible: false
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "joinOrganisation", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var joinOrganisation, _ref5, data, error;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              joinOrganisation = _this.props.joinOrganisation;

              _this.setState({
                saving: true
              });

              _context2.next = 4;
              return joinOrganisation();

            case 4:
              _ref5 = _context2.sent;
              data = _ref5.data;
              error = _ref5.error;

              if (!(error || !data)) {
                _context2.next = 9;
                break;
              }

              return _context2.abrupt("return", void _this.setState({
                error: error,
                saving: false
              }));

            case 9:
              _this.setState({
                redirectToHome: true,
                saving: false
              });

            case 10:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    })));

    _this.state = {
      playing: false,
      video: void 0,
      videoUrl: '',
      redirectToHome: false,
      captionsVisible: false,
      saving: false,
      error: false
    };
    return _this;
  }

  _createClass(OrganisationWelcomeContent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.fetchVideo();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var video = this.state.video;

      if (video) {
        video.removeEventListener('pause', this.handleStop);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state2 = this.state,
          playing = _this$state2.playing,
          saving = _this$state2.saving,
          redirectToHome = _this$state2.redirectToHome,
          error = _this$state2.error,
          videoUrl = _this$state2.videoUrl;
      var organisation = this.props.organisation;

      if (saving) {
        return _react.default.createElement(_uiKit.Loader, {
          text: "Setting up your workspace..."
        });
      }

      if (redirectToHome) {
        return _react.default.createElement(_reactRouterDom.Redirect, {
          to: "/"
        });
      }

      return _react.default.createElement("div", {
        className: "org-invite"
      }, _react.default.createElement("div", {
        className: "org-invite__video",
        style: {
          opacity: playing ? 1 : 0.2,
          zIndex: playing ? 1 : -1
        }
      }, videoUrl ? _react.default.createElement("video", {
        id: "welcome-video",
        src: videoUrl,
        controls: playing,
        ref: this.getVideo
      }, _react.default.createElement("track", {
        kind: "captions",
        src: _whyShootsta.default,
        srcLang: "en"
      })) : null), _react.default.createElement("div", {
        className: "org-invite__content",
        style: {
          opacity: playing ? 0 : 1
        }
      }, _react.default.createElement(_FormHeader.default, {
        title: "Welcome to ".concat(organisation.name),
        subtitle: "Get Started"
      }), _react.default.createElement("div", {
        className: "org-invite__content__play-container"
      }, !playing ? _react.default.createElement(_uiKit.Text, {
        heading1: true
      }, "WHY SHOOTSTA") : null, _react.default.createElement("button", {
        type: "button",
        className: "org-invite__content__play-btn",
        onClick: this.handlePlay
      }, _react.default.createElement(_uiKit.Icon, {
        color: "white",
        name: "play"
      }), "Play Video")), _react.default.createElement(_uiKit.Button, {
        "data-cy": "join-org-button",
        onClick: this.joinOrganisation
      }, "Join"), error ? _react.default.createElement(_uiKit.Text, {
        danger: true,
        heading4: true,
        className: "org-invite__error"
      }, error) : null));
    }
  }]);

  return OrganisationWelcomeContent;
}(_react.Component);

exports.default = OrganisationWelcomeContent;